export default {
      id: "user-usage",
      viewBox: "0 0 14 15",
      url: __webpack_public_path__ + "icons.svg#user",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/user.svg
// module id = 290
// module chunks = 0